import { useState, useEffect } from "react";
import { u as ue } from "./storyblok-js-5fd880b4.mjs";
const useStoryblokState = (initialStory = null, bridgeOptions = {}) => {
  let [story, setStory] = useState(initialStory);
  const isBridgeEnable = typeof window !== "undefined" && typeof window.storyblokRegisterEvent !== "undefined";
  if (!isBridgeEnable || !initialStory) {
    return initialStory;
  }
  const id = story.internalId || story.id;
  useEffect(() => {
    setStory(initialStory);
    ue(
      id,
      (newStory) => setStory(newStory),
      bridgeOptions
    );
  }, [initialStory]);
  return story;
};
export {
  useStoryblokState as u
};
